import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import './DonateType.scss';

const DonateType = props => {
  return (
    <div className="col-md-4 col-sm-12 text-center donate-type-column">
      <div className="donate-type-inner">
        <h3>{props.title}</h3>
        <p>{props.content}</p>
        {props.to ? (
          <Link
            scroll={el =>
              el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
            to={props.to}
          >
            Mehr Info <i className="far fa-long-arrow-right" />
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default DonateType;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/DonateType.js